exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js
// module id = 449
// module chunks = 0